export default __webpack_public_path__ + "static/Acta-Book-7e64bc9ad974858d4cc7cdc029c970a3.woff2";